import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './settings.types';
import * as constants from './settings.constants';

export const storeSettings = generateStoreResourceAction<types.ISettings>(constants.STORE_SETTINGS);
export const clearSettings = generateClearResourceAction(constants.CLEAR_SETTINGS);
